// extracted by mini-css-extract-plugin
module.exports = {"MessageContainer":"SectionMessage_MessageContainer__1WvQD","Checkmark":"SectionMessage_Checkmark__29r5_","MessageText":"SectionMessage_MessageText__2z2tj"};